import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/reviews/ReviewsPageClient.tsx");
